// src/components/BackgroundController.jsx
import { useEffect, useState, useRef } from "react";

const backgrounds = {
  intro: "/assets/bg1.mp4",
  structure: "/assets/bg1.mp4",
  apply: "/assets/bg1.mp4",
  media: "/assets/bg1.mp4",
  discord: "/assets/bg1.mp4",
};

export default function BackgroundController() {
  const [currentKey, setCurrentKey] = useState("intro");
  const [overlayVisible, setOverlayVisible] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const lastVisibleKey = useRef("intro");

  useEffect(() => {
    const sectionMap = {
      intro: "intro",
      structure: "structure",
      apply: "apply",
      media: "media",
      discord: "discord",
    };

    const observer = new IntersectionObserver(
      (entries) => {
        const topEntry = entries.find(
          (entry) =>
            entry.isIntersecting &&
            entry.intersectionRatio >= 0.5
        );
        if (!topEntry) return;

        const sectionId = topEntry.target.id;
        const newKey = sectionMap[sectionId];
        if (
          !newKey ||
          newKey === lastVisibleKey.current ||
          isTransitioning
        ) {
          return;
        }

        const newBg = backgrounds[newKey];
        const currentBg = backgrounds[currentKey];
        if (newBg === currentBg) {
          lastVisibleKey.current = newKey;
          setCurrentKey(newKey);
          return;
        }

        setIsTransitioning(true);
        setOverlayVisible(true);
        setTimeout(() => {
          setCurrentKey(newKey);
          lastVisibleKey.current = newKey;
        }, 150);
        setTimeout(() => {
          setOverlayVisible(false);
          setIsTransitioning(false);
        }, 300);
      },
      { threshold: [0.5] }
    );

    Object.keys(sectionMap).forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [currentKey, isTransitioning]);

  return (
    <>
      {/* 🎬 Video Background */}
      <video
        // ← use /assets/bg1.mp4 directly
        key={backgrounds[currentKey]}
        className="fixed inset-0 w-full h-full object-cover -z-40"
        src={backgrounds[currentKey]}
        autoPlay
        muted
        loop
        playsInline
      />

      {/* 🌓 Readability Overlay */}
      <div
        className="fixed inset-0 -z-30 pointer-events-none"
        style={{ backgroundColor: "rgba(0, 0, 0, 0.15)" }}
      />

      {/* 🌑 Fade to black during transition */}
      <div
        className={`fixed inset-0 -z-20 bg-black transition-opacity duration-300 pointer-events-none ${
          overlayVisible ? "opacity-100" : "opacity-0"
        }`}
      />
    </>
  );
}
